import React from 'react';
import { Grid } from '@mui/material';
import CreateSparkHeader from './CreateSparkHeader';
import CreateSparkContainer from './CreateSparkContainer';
import { ReactFlowProvider } from 'reactflow';
import { useParams } from 'react-router-dom';
import { useSparkStepsBySparkID } from 'hooks/SparkBuilder/sparkStep';
import { useSparksByID } from 'hooks/spark';
import { useSparkBuilderStore } from 'stores';
import {
  useSparkStepsBySparkIDHelper,
  useSparkStepTypeHelper,
} from 'stores/sparkBuilderStore';
import CreateSparkOnboarding from './CreateSparkOnboarding';
import { useSparkStepTypes } from 'hooks/EntityTypes/useSparkStepTypes';

export default function CreateSpark() {
  const { id: sparkID = null } = useParams();
  const storeSparkID = useSparkBuilderStore((state) => state.sparkID);
  const sparkStepsBySparkIDHelper = useSparkStepsBySparkIDHelper();
  const setJoinedSpark = useSparkBuilderStore((state) => state.setJoinedSpark);
  const resetSparkBuilderStore = useSparkBuilderStore(
    (state) => state.resetStore
  );
  const onSparkStepTypeSuccess = useSparkStepTypeHelper();

  //do not remove
  const { idMap } = useSparkStepTypes();
  const { sparkSteps } = useSparkStepsBySparkID(sparkID);
  const { joinedSpark } = useSparksByID(sparkID);
  const [elementRef, setElementRef] = React.useState(() =>
    React.createRef<HTMLElement>()
  );

  React.useEffect(() => {
    if (elementRef.current) {
      setElementRef(elementRef);
    }
  }, [elementRef]);

  React.useEffect(() => {
    // if the component unmounts, make sure to reset the spark builder store
    return () => resetSparkBuilderStore();
  }, [resetSparkBuilderStore]);

  React.useEffect(() => {
    if (storeSparkID === sparkID) {
      return;
    }
    if (!joinedSpark || !sparkSteps || !idMap) {
      return;
    }
    setJoinedSpark(joinedSpark);
    onSparkStepTypeSuccess(idMap);
    sparkStepsBySparkIDHelper.onSuccess(sparkSteps);
  }, [
    idMap,
    joinedSpark,
    onSparkStepTypeSuccess,
    setJoinedSpark,
    sparkID,
    sparkSteps,
    sparkStepsBySparkIDHelper,
    storeSparkID,
  ]);

  const headerHeight = elementRef.current?.getBoundingClientRect().height || 0;
  return (
    <ReactFlowProvider>
      {!sparkID ? (
        <CreateSparkOnboarding />
      ) : (
        <Grid container direction='column'>
          <CreateSparkHeader ref={elementRef} />
          <CreateSparkContainer headerHeight={headerHeight} />
        </Grid>
      )}
    </ReactFlowProvider>
  );
}
